import styled from 'styled-components';
import { gridRowCenter } from 'theme/mixins';

export const Wrapper = styled.div`
    ${gridRowCenter};
    width: max-content;
    background-color: white;
    padding: 3rem 5rem;
    box-shadow: 1px 1px 25px 1px #33333377;
    border-radius: ${({ theme }) =>
        theme?.defaults?.borderRadius ? theme.defaults.borderRadius : '1rem'};
`;
